import script from "./OnboardingAiIntervalOptionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingAiIntervalOptionCard.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingAiIntervalOptionCard.vue?vue&type=style&index=0&id=c58f9c06&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c58f9c06"]])

export default __exports__